import {
  defaultShouldDehydrateQuery,
  QueryClient,
} from "@tanstack/react-query";
import * as superjson from "superjson";

import { toast } from "@workspace/ui/components/toast";

import { env } from "../../env.config";

import type { TRPCClientError } from "@trpc/client";
import type { AppRouter } from "@workspace/api";

export const transformer = superjson;

const getBaseUrl = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  if (env.VERCEL_URL) {
    return `https://${env.VERCEL_URL}`;
  }
  // eslint-disable-next-line no-restricted-properties, turbo/no-undeclared-env-vars
  return `http://localhost:${process.env.PORT ?? 3000}`;
};
export function getUrl() {
  return `${getBaseUrl()}/api/trpc`;
}

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
      },
      dehydrate: {
        serializeData: superjson.serialize,
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
      hydrate: {
        deserializeData: superjson.deserialize,
      },
      mutations: {
        onError: (
          error: Error | TRPCClientError<AppRouter> | { error: Error },
        ) => {
          if ("error" in error && !(error instanceof Error)) {
            ({ error } = error);
          }

          console.error(error);

          if ("data" in error) {
            return toast.add({
              title: error.data?.zodError ?? error.message,
              type: "error",
            });
          }

          toast.add({ title: error.message, type: "error" });
        },
      },
    },
  });
